<template>
    <el-breadcrumb separator="/" class="pcr-tree-breadcrumb">
        <el-breadcrumb-item v-for="item in breadcrumb" :key="item.Id" :to="{ query: { establishmentId: item.Id } }">{{item.Label}}</el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
import Vue from 'vue';
export default Vue.component('pcr-breadcrumb', {
    props: {
        current: {
            type: Object,
            default: () => null
        },
        currentUser: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            tree: [],
            breadcrumb: []
        }
    },
    computed: {
    },

    mounted: function () {
        this.refresh();
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/establishment/tree').then((response) => {
                    this.tree = response.data;

                    this.makeBreadCrumb()
                    this.refreshing = false;
                });
            }
        },

        findDeepInTree(tree, predicate) {
            var result = _.find(tree, predicate);

            if (result) return result;

            var children = _.flatten(_.map(tree, (x) => x.Children));

            if(!children || !children.length) return null;

            result = this.findDeepInTree(children, predicate);

            return result;
        },

        makeBreadCrumb() {
            this.breadcrumb = [];

            var c = this.current;

            if(!c) return;

            this.breadcrumb.push(c);
            c = this.findDeepInTree(this.tree, (x) => x && x.Id == c.ParentId);

            while (c) {
                if (c) this.breadcrumb.push(c);
                c = this.findDeepInTree(this.tree, (x) => x && x.Id == c.ParentId);
            }

            this.breadcrumb = this.breadcrumb.reverse();
        }
    },

    watch: {
        current(val) {
            // if(_.some(this.breadcrumb, val)) return;

            if (val) {
                if(val.Type == 'User') {
                    this.$http.get('/api/user/' + val.Id).then((response) => {
                        //get user label
                        val.Label = response.data.LastName + ' ' + response.data.FirstName;
                        this.makeBreadCrumb();
                    });
                }
                else {
                    this.makeBreadCrumb();
                }
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/visual/pcr-breadcrumb.vue